import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToggleGreenOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#B0BEC5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgToggleGreenOff);
export { ForwardRef as ReactComponent };
